/*
 *   Menti-display-compressed (Mentimeter Brand Font)
 */

const regular = {
  files: [
    'https://static.mentimeter.com/static/fonts/web/menti-display-compressed/1.0/MentiDisplay-Compressed.woff2',
    'https://static.mentimeter.com/static/fonts/web/menti-display-compressed/1.0/MentiDisplay-Compressed.woff',
    'https://static.mentimeter.com/static/fonts/web/menti-display-compressed/1.0/MentiDisplay-Compressed.ttf',
  ],
  style: { fontDisplay: 'swap', fontWeight: '400' },
};

export const MentiDisplayCompressed = {
  regular,
};

export const mentiDisplayCompressedKeys = Object.keys(
  MentiDisplayCompressed,
) as Array<keyof typeof MentiDisplayCompressed>;
